module.exports = __webpack_public_path__ + "e3287825c7c2d31c490f4deeb8ef795b.webm";